export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11164.3e3e86cd.jpg";